import { render } from "./NewAccountCreationDialog.vue?vue&type=template&id=0796a55d"
import script from "./NewAccountCreationDialog.vue?vue&type=script&lang=js"
export * from "./NewAccountCreationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__